import styled from 'styled-components'
import { Button } from '@stokr/components-library'
import { stoColor, stoMedia, stoRadius, stoSpace, stoType } from 'constants/stoTheme'

const MOBILE = stoMedia.belowDesktop

export const Description = styled.p`
  ${stoType.bodyText};
  margin: 0;
  color: ${stoColor.textPrimary};
`

export const ActionRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${stoSpace[4]};

  /* Figma 3582:128652: stacked, full width, centred. */
  ${MOBILE} {
    flex-direction: column;
    align-items: stretch;

    & > * {
      justify-content: center;
    }
  }
`

const actionBase = `
  ${stoType.labelCta};
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  border-radius: ${stoRadius.full};
  text-decoration: none;
  cursor: pointer;
`

/**
 * The shared `Button` in its `black` variant (transparent, black border/label, fills
 * black on hover/focus/active) — same CTA look as Trade's and HowToInvest's actions,
 * sized down to this row's compact pill. Only sizing/typography is overridden; colors,
 * borders and hover/active states all come from the library.
 *
 * `color` is set per-state (not one blanket `!important`): a real external `<a>` here
 * hits the same global `a { color: inherit !important }` anti-leak rule in
 * `style/base.js` at rest, but the library's own hover state already turns the label
 * white once the background fills black — restating that state, not overriding it.
 */
export const ContactButton = styled(Button)`
  ${stoType.labelCta};
  display: inline-flex;
  align-items: center;
  min-height: auto;
  padding: 6px 16px;
  gap: 8px;
  color: ${stoColor.black} !important;

  &:hover,
  &:focus,
  &:active {
    color: ${stoColor.buttonLabelOnFill} !important;
  }
`

export const CopyEmailButton = styled.button`
  ${actionBase};
  border: none;
  background: transparent;
  color: ${stoColor.textSecondary};

  &:hover {
    color: ${stoColor.textPrimary};
  }
`
